import { render } from "./ReportsListingEmptyStateFavorite.vue?vue&type=template&id=f8f52cd4"
import script from "./ReportsListingEmptyStateFavorite.vue?vue&type=script&lang=js"
export * from "./ReportsListingEmptyStateFavorite.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__